import React, {useState} from 'react';
import moment from 'moment';
import TimeSlot from './timeSlot';
import { isMobile } from '../../../../../../../utils/mobile';
import { days } from '../../../../../../../constants';

export default function VerticalLineSchedule({
  schedule = [],
  searchFilters,
  setDocСalendarDate,
  date,
}) {
  
  if(searchFilters?.onlyAvailable && schedule.status !== 'FREE' || schedule.length === 0) {
    if(isMobile()) {
      const day = moment(date).format('DD.MM');
      const ofweek = days[moment(date).format('dddd')].short;
      return (<div className={`schedule-time-list__item schedule-time-list__title more empty`}>
        <span className="time-range"><span className='timeRangeText empty'><span className='dayRangeText'>{day}, {ofweek}</span></span></span>
      </div>);
    }
    return <li className="schedule-time-list__item empty" />;
  }
  // Get time format for display 
  const getTimeRangeText = () => {
    
    const day = moment(date).format('DD.MM');
    const ofweek = days[moment(date).format('dddd')].short;

    const firstSlotTime = moment(schedule.time_from).format('HH:mm');
    const lastSlotTime = moment(schedule.time_to).format('HH:mm');
    if(isMobile()) {
      return (<><span className='dayRangeText'>{day}, {ofweek}</span><i></i><span className='timeRangeText'>{firstSlotTime} - {lastSlotTime}</span></>);
    }
    return (<span className='timeRangeText'>{firstSlotTime} <i></i> {lastSlotTime}</span>);
  };

  return (
    <>
      <div className={`schedule-time-list__item schedule-time-list__title more ${schedule.status !== 'FREE' ? 'past' : ''} ${schedule.is_booked_by_patient === true ? 'booked_by_patient' : ''}`} onClick={() => { setDocСalendarDate(moment(schedule.time_from).format('YYYY-MM-DD')) }}>
        <span className="time-range">{ getTimeRangeText() }</span>
      </div>
    
    </>
  );
}
